export default __webpack_public_path__ + "cakephp.a6e06755.png";